import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

// Preloader
document.addEventListener("DOMContentLoaded", (event) =>{
  
    window.onload = () => {
        const preloaderTimeline = gsap.timeline({ defaults: { ease: 'power2.out' }});
        preloaderTimeline.from('.js-preloader', { duration: 1, opacity: 1 });
        preloaderTimeline.to('.js-preloader', { x: '100%', duration: 1 });
    };
  
});

// Cursor
let cursor = document.querySelector('.js-cursor');

const setCursorNoneImportant = () => {
    document.querySelectorAll("*").forEach(element => {
        element.style.setProperty('cursor', 'none', 'important');
    });
}

const resetCursorStyles = () => {
    document.querySelectorAll("*").forEach(element => {
        element.style.removeProperty('cursor');
    });
}

document.addEventListener('mousemove', moveCursor);

function moveCursor(e) {
    let x = e.clientX;
    let y = e.clientY;

    cursor.style.left = `${x}px`;
    cursor.style.top = `${y}px`;
}

let links = Array.from(document.querySelectorAll("a", "button", "select", "iframe", "input"));

if (links) {
    links.forEach((link) => {
        link.addEventListener("mouseover", () => {
            cursor.classList.add("grow");
        });

        link.addEventListener("mouseleave", () => {
            cursor.classList.remove("grow");
        });
    });
}

const iframes = document.querySelectorAll("iframe");

if (iframes) {
    iframes.forEach((iframe) => {
        iframe.addEventListener("mouseenter", function() {
            cursor.style.display = 'none';
            setCursorNoneImportant();
        })
        
        iframe.addEventListener("mouseleave", function() {
            cursor.style.display = shouldDisplayCursor() ? 'block' : 'none';
        })
    })
}

const shouldDisplayCursor = () => {
    if (window.innerWidth >= 1024) {
        cursor.style.display = 'block';
        setCursorNoneImportant();
        return true;
    } else {
        cursor.style.display = 'none';
        resetCursorStyles();
        return false;
    }
}

shouldDisplayCursor();

window.addEventListener('resize', shouldDisplayCursor);

// Testimonial text colour reveal
const splitTypes = document.querySelectorAll(".js-reveal-testimonial");

if (splitTypes) {
    splitTypes.forEach((char, i) => {
        const text = new SplitText(char, { type: "chars, words" });
        
        gsap.from(text.chars, {
            scrollTrigger: {
                trigger: char,
                start: "top 75%",
                end: "top 20%",
                scrub: true,
            },
            opacity: 0.25,
            stagger: 0.1,
        });
    });
}

// Number increment
const ourImpactSection = document.querySelector('[data-block="our-impact"]');
const counters = document.querySelectorAll('[data-count-start]');

if (ourImpactSection) {
    ScrollTrigger.create({
        trigger: ourImpactSection,
        start: '-25% center',
        once: true,
        onEnter: () => {
            counters.forEach((counter) => {
                const endValue = parseFloat(counter.getAttribute('data-count-end'));
                
                gsap.fromTo(counter, 
                    { innerText: 0 }, 
                    { 
                        innerText: endValue, 
                        duration: 3, 
                        snap: { innerText: 0.1 }, 
                        ease: 'power1.inOut', 
                        onUpdate: () => {
                            counter.innerText = parseFloat(counter.innerText).toLocaleString();
                        } 
                    }
                );
            });
        },
    });
}

// Borders
let borders = document.querySelectorAll('.js-border-reveal');

if (borders) {
    borders.forEach((border) => {
        ScrollTrigger.create({
            trigger: border,
            start: '-=150px center',
            once: true,
            onEnter: () => {
                gsap.fromTo(border, { width: '0' }, { width: '100%', duration: 1.5, ease: 'power4.out' });
            },
        });
    });
}